import { render, staticRenderFns } from "./UploadPdf.vue?vue&type=template&id=2fe94c29&scoped=true&"
import script from "./UploadPdf.vue?vue&type=script&lang=js&"
export * from "./UploadPdf.vue?vue&type=script&lang=js&"
import style0 from "./UploadPdf.vue?vue&type=style&index=0&id=2fe94c29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe94c29",
  null
  
)

export default component.exports